import { iSettings, iWordHistory } from "@/lib/types";
import { useLocalStorage } from "./useLocalStorage";

export const useHistory = () => {
  const [settings, setSettingsHandler] = useLocalStorage<iSettings>(
    "settings",
    {
      strong: true,
      medium: true,
      weak: true,
      new: true,
    },
  );

  const [wordHistory, setWordHistory] = useLocalStorage<iWordHistory>(
    "wordHistory",
    {},
  );

  const setSettings = (newSettings: Partial<iSettings>) => {
    setSettingsHandler({ ...settings, ...newSettings });
  };

  return {
    settings,
    setSettings,
    wordHistory,
    setWordHistory,
  };
};
